import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

/**
 * Thai is the default because the pilot's customers are Thai salon owners.
 * English exists from the start so adding a third language later is translation work
 * rather than refactoring.
 */

const th = {
  app: {
    name: 'ระบบแชท AI',
    signOut: 'ออกจากระบบ',
    reconnecting: 'กำลังเชื่อมต่อใหม่ ข้อมูลอาจไม่ล่าสุด',
    disconnected: 'ขาดการเชื่อมต่อ',
  },
  nav: {
    inbox: 'กล่องข้อความ',
    dashboard: 'ภาพรวม',
    knowledge: 'ความรู้',
    simulator: 'ทดลองแชท',
    settings: 'ตั้งค่า',
    admin: 'ผู้ใช้งาน',
    platform: 'ผู้ดูแลระบบ',
    more: 'เพิ่มเติม',
    openCount: 'บทสนทนาที่เปิดอยู่ {{count}} รายการ',
    waitingCount: 'รอเจ้าหน้าที่ {{count}} รายการ',
  },
  auth: {
    title: 'เข้าสู่ระบบ',
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    signIn: 'เข้าสู่ระบบ',
    failed: 'เข้าสู่ระบบไม่สำเร็จ',
    unreachable: 'ติดต่อเซิร์ฟเวอร์ไม่ได้ กรุณาลองใหม่อีกครั้ง',
    forgotHint: 'ลืมรหัสผ่าน? ขอลิงก์ตั้งรหัสใหม่จากผู้ดูแลพื้นที่ทำงานของคุณ',
  },
  dashboard: {
    whatIsCounted: 'นับอะไรบ้าง',
    inTimezone: 'นับวันตามเวลา {{timezone}}',
    definitions: {
      conversations: 'บทสนทนาที่เริ่มในช่วงนี้ และข้อความจากลูกค้าในช่วงนี้ นับวันตามเวลาของพื้นที่ทำงาน',
      answered:
        'สัดส่วนรอบที่ AI ตอบแล้วข้อความถึงลูกค้าจริง เทียบกับรอบที่ AI ตอบหรือส่งต่อให้เจ้าหน้าที่ คำตอบที่ส่งไม่สำเร็จหรือถูกยกเลิกเพราะเจ้าหน้าที่รับเรื่องต่อไม่นับ',
      handoffWait:
        'มัธยฐานของเวลาตั้งแต่ AI ส่งต่อจนเจ้าหน้าที่ตอบและข้อความถึงลูกค้า ที่ยังไม่มีใครตอบแสดงแยก เวลาตอบครั้งแรกคือเวลาจากข้อความแรกของลูกค้าถึงคำตอบแรกที่ส่งถึงจริง',
      cost: 'ประมาณการจากราคารุ่นที่ตั้งไว้ รวมเฉพาะการตอบและการอ่านรูป ไม่รวมการค้นหาความรู้และรอบที่ล้มเหลวก่อนสลับรุ่นสำรอง',
    },
    title: 'ภาพรวม',
    days: 'วัน',
    conversations: 'บทสนทนา',
    customerMessages: 'ข้อความจากลูกค้า',
    answeredShare: 'AI ตอบเองได้',
    turns: 'ครั้ง',
    firstResponse: 'ตอบครั้งแรก',
    handoffWait: 'รอเจ้าหน้าที่ (ค่ากลาง)',
    handoffs: 'ครั้งที่ส่งต่อ',
    noneAnswered: 'ยังไม่มีเจ้าหน้าที่รับเรื่องที่ส่งต่อ',
    stillUnanswered: 'ยังไม่มีคนตอบ {{count}} ครั้ง',
    peak: 'สูงสุด',
    tokens: 'โทเคน',
    notPriced: 'ยังไม่ได้ตั้งราคา',
    volumeSummary: 'บทสนทนา {{total}} รายการใน {{days}} วัน สูงสุด {{peak}} รายการต่อวัน',
    cost: 'ค่าใช้จ่ายโดยประมาณ',
    seconds: 'วินาที',
    minutes: 'นาที',
    hours: 'ชั่วโมง',
    volume: 'ปริมาณบทสนทนา',
    handoffReasons: 'เหตุผลที่ส่งต่อให้คน',
    handoffHint: 'รายการนี้บอกว่าควรเพิ่มความรู้เรื่องใดก่อน',
    noHandoffs: 'ยังไม่มีการส่งต่อ',
    channels: 'ช่องทาง',
    noTraffic: 'ยังไม่มีบทสนทนา',
    waitingNow: 'บทสนทนากำลังรอเจ้าหน้าที่อยู่ตอนนี้',
    feedback: 'ความเห็นต่อคำตอบของ AI',
    feedbackUp: 'ตอบดี',
    feedbackDown: 'ตอบไม่ดี',
    downReasons: 'เหตุผลที่ตอบไม่ดี',
    noFeedback: 'ยังไม่มีใครให้ความเห็น',
    feedbackHint: 'เหตุผลเหล่านี้บอกว่าควรแก้อะไรก่อน',
    reviewQueueNow: 'บทสนทนาที่ AI ตอบเองและยังไม่มีใครตรวจ',
  },
  inbox: {
    loadFailed: 'โหลดรายการสนทนาไม่สำเร็จ',
    loadMore: 'โหลดเพิ่ม',
    search: 'ค้นหาชื่อ เบอร์โทร แท็ก หรือข้อความ',
    noMatches: 'ไม่พบบทสนทนาที่ตรงกันในแท็บนี้',
    image: 'รูปภาพ',
    deliveryQueued: 'รอส่ง',
    deliverySent: 'ส่งแล้ว',
    deliveryDelivered: 'ถึงผู้รับแล้ว',
    deliveryRead: 'อ่านแล้ว',
    deliveryFailed: 'ส่งไม่สำเร็จ',
    resend: 'ส่งอีกครั้ง',
    resending: 'กำลังส่ง…',
    deliveryCanceled: 'ไม่ได้ส่ง เพราะเจ้าหน้าที่รับเรื่องต่อแล้ว',
    deliveryUncertain: 'ไม่แน่ใจว่าส่งถึงหรือไม่',
    deliveryUncertainHint: 'แพลตฟอร์มไม่ตอบกลับ ข้อความอาจส่งถึงแล้ว ระบบจะไม่ส่งซ้ำเอง โปรดตรวจสอบก่อนส่งใหม่',
    openImage: 'เปิดในแท็บใหม่',
    title: 'กล่องข้อความ',
    empty: 'ยังไม่มีบทสนทนา',
    waiting: 'รอเจ้าหน้าที่',
    review: 'ตรวจทาน',
    filters: { all: 'ทั้งหมด', open: 'เปิดอยู่', resolved: 'จบแล้ว', unassigned: 'ยังไม่มีผู้รับ' },
    searchPlaceholder: 'ค้นหา',
  },
  mcp: {
    title: 'เซิร์ฟเวอร์ MCP',
    hint: 'เชื่อมเซิร์ฟเวอร์ MCP ของคุณ แล้วเลือกว่า AI ใช้เครื่องมือใดได้บ้าง เครื่องมือที่ไม่ได้ติ๊กจะไม่ถูกเสนอให้ AI เลย และทุกเครื่องมือต้องระบุว่าแค่อ่านหรือเปลี่ยนแปลงข้อมูล',
    none: 'ยังไม่ได้เชื่อมเซิร์ฟเวอร์',
    loadFailed: 'โหลดเซิร์ฟเวอร์ MCP ไม่สำเร็จ',
    add: 'เชื่อมเซิร์ฟเวอร์',
    name: 'ชื่อ (ใช้นำหน้าชื่อเครื่องมือ)',
    url: 'URL ของเซิร์ฟเวอร์',
    auth: 'การยืนยันตัวตน',
    authHeader: 'โทเคนในเฮดเดอร์',
    authOAuth: 'ลงชื่อเข้าใช้ (OAuth)',
    oauthWarning:
      'AI จะเรียกเซิร์ฟเวอร์นี้ในนามบัญชีที่ลงชื่อเข้าใช้ สำหรับลูกค้าทุกคน ควรใช้บัญชีสำหรับระบบโดยเฉพาะ ไม่ใช่บัญชีส่วนตัว',
    signIn: 'ลงชื่อเข้าใช้',
    signInAgain: 'ลงชื่อเข้าใช้ใหม่',
    signedIn: 'ลงชื่อเข้าใช้แล้ว',
    notSignedIn: 'ยังไม่ได้ลงชื่อเข้าใช้',
    signedInNow: 'ลงชื่อเข้าใช้เซิร์ฟเวอร์ MCP เรียบร้อย',
    signInFailed: 'ลงชื่อเข้าใช้เซิร์ฟเวอร์ MCP ไม่สำเร็จ ลองอีกครั้ง',
    disconnect: 'ออกจากระบบ',
    authNone: 'ไม่มี',
    headerName: 'ชื่อเฮดเดอร์',
    token: 'โทเคน (เก็บแบบเข้ารหัส ไม่แสดงอีก)',
    connect: 'เชื่อม',
    enabled: 'เปิดใช้',
    allowedCount: 'อนุญาต {{count}} เครื่องมือ',
    needsReconnect: 'ต้องลงชื่อเข้าใช้ใหม่',
    fetch: 'ดึงรายการเครื่องมือ',
    refetch: 'ดึงรายการใหม่',
    cost: 'เพิ่มในทุกบทสนทนาประมาณ {{tokens}} โทเคน',
    tooLarge: 'คำอธิบายของเครื่องมือนี้ใหญ่เกินกว่าจะเสนอให้ AI',
    effect: 'ผลของเครื่องมือ',
    chooseEffect: 'เลือกว่าอ่านหรือเขียน',
    binding: 'ค่าของ {{name}}',
    modelFills: 'AI เป็นผู้ใส่',
    saveAllowed: 'บันทึกเครื่องมือที่อนุญาต',
    undecided: 'บางเครื่องมือยังไม่ได้เลือกว่าอ่านหรือเขียน',
    test: 'ทดสอบเครื่องมือ',
    testArgs: 'อาร์กิวเมนต์ (JSON)',
    testRun: 'ทดสอบ',
    testWrites: 'เครื่องมือนี้เขียนข้อมูล การทดสอบจะเปลี่ยนข้อมูลจริงในระบบของคุณ',
  },
  tags: {
    label: 'แท็ก',
    add: 'เพิ่มแท็ก',
    remove: 'เอาแท็ก {{tag}} ออก',
    filter: 'กรองตามแท็ก',
    filterBy: 'แสดงเฉพาะแท็ก {{tag}}',
    removeFilter: 'เลิกกรองแท็ก {{tag}}',
    clearFilter: 'ล้างทั้งหมด',
    cardTitle: 'แท็ก',
    cardHint: 'แท็กทั้งหมดในพื้นที่ทำงานนี้ เปลี่ยนชื่อเป็นแท็กที่มีอยู่แล้วเพื่อรวมเป็นแท็กเดียว ลบแล้วแท็กจะหายจากทุกบทสนทนา',
    empty: 'ยังไม่มีแท็ก',
    loadFailed: 'โหลดแท็กไม่สำเร็จ',
    used: '{{count}} บทสนทนา',
    rename: 'เปลี่ยนชื่อ',
    newName: 'ชื่อใหม่',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    delete: 'ลบทุกที่',
    confirmDelete: 'ยืนยันลบ',
    topTitle: 'แท็กที่ใช้มากที่สุด',
    topDefinition: 'บทสนทนาที่มีข้อความในช่วงนี้ แยกตามแท็ก และจำนวนที่ถูกส่งต่อให้เจ้าหน้าที่ในช่วงเดียวกัน',
    topHandoffs: 'ส่งต่อ {{count}}',
    noTags: 'ยังไม่มีบทสนทนาที่ติดแท็กในช่วงนี้',
  },
  modes: {
    ai: 'AI ตอบ',
    ai_supervised: 'AI ร่าง',
    human: 'เจ้าหน้าที่',
    waiting_human: 'รอเจ้าหน้าที่',
  },
  conversation: {
    notAvailable: 'เปิดบทสนทนานี้ไม่ได้ อาจถูกลบหรือคุณไม่มีสิทธิ์',
    loadFailed: 'โหลดบทสนทนาไม่สำเร็จ',
    sendFailed: 'ส่งข้อความไม่สำเร็จ ข้อความยังอยู่ในช่องพิมพ์',
    newMessages: 'มีข้อความใหม่',
    readOnly: 'คุณดูได้อย่างเดียว การตอบลูกค้าต้องใช้สิทธิ์เจ้าหน้าที่',
    takeOver: 'รับช่วงต่อ',
    returnToAi: 'ส่งคืน AI',
    returnNote: 'ข้อความถึง AI (ไม่บังคับ)',
    placeholder: 'พิมพ์ข้อความ...',
    send: 'ส่ง',
    internalNote: 'บันทึกภายใน',
    addNote: 'เพิ่มบันทึก',
    resolve: 'ปิดบทสนทนา',
    reopen: 'เปิดอีกครั้ง',
    noMessages: 'ยังไม่มีข้อความ',
    handoffReason: 'เหตุผลที่ส่งต่อ',
    handoffReasons: {
      ai_requested: 'AI ขอส่งต่อเอง',
      customer_requested: 'ลูกค้าขอคุยกับเจ้าหน้าที่',
      low_confidence: 'AI ไม่มั่นใจคำตอบ',
      negative_sentiment: 'ลูกค้าไม่พอใจ',
      keyword_rule: 'ตรงกับคำที่ตั้งให้ส่งต่อ',
      unsupported_media: 'ไฟล์ที่ AI อ่านไม่ได้',
      tool_error: 'เครื่องมือทำงานไม่สำเร็จ',
      model_error: 'เรียกโมเดลไม่สำเร็จ',
    },
    selectPrompt: 'เลือกบทสนทนาเพื่อเริ่ม',
    loadOlder: 'ดูข้อความก่อนหน้า',
    backToList: 'กลับไปที่รายการ',
    attach: 'แนบไฟล์',
  },
  sidebar: {
    identityVerified: 'ยืนยันตัวตนแล้ว',
    identityUnverified: 'ยังไม่ได้ยืนยันตัวตน',
    identityVia: { widget_token: 'ผ่านเว็บไซต์', verification_link: 'ผ่านลิงก์ยืนยัน' },
    sendVerificationLink: 'ส่งลิงก์ยืนยันตัวตน',
    verificationLinkSent: 'ส่งลิงก์แล้ว',
    erase: 'ลบข้อมูลลูกค้ารายนี้',
    eraseConfirm: 'ยืนยันการลบถาวร',
    eraseWho: 'ลบข้อมูลทั้งหมดของ {{name}}?',
    erasing: 'กำลังลบ...',
    eraseQueued: 'ส่งคำสั่งลบแล้ว ข้อมูลจะถูกลบทั้งหมด',
    eraseHint: 'ลบทุกบทสนทนา รูปภาพ และข้อมูลของลูกค้ารายนี้ ย้อนกลับไม่ได้',
    review: 'การตรวจทาน',
    inReviewQueue: 'AI ตอบบทสนทนานี้เองโดยยังไม่มีใครตรวจ',
    markReviewed: 'ตรวจทานแล้ว',
    suggestion: 'ข้อความที่ AI แนะนำ',
    insert: 'ใส่ในช่องพิมพ์',
    insertAndSend: 'ใส่และส่ง',
    discard: 'ไม่ใช้',
    noSuggestion: 'ยังไม่มีคำแนะนำ',
    title: 'ข้อมูล AI และลูกค้า',
    customer: 'ข้อมูลลูกค้า',
    fields: {
      phone: 'เบอร์โทร',
      email: 'อีเมล',
      order_id: 'เลขออร์เดอร์',
      account_id: 'รหัสบัญชี',
      company: 'บริษัท',
    },
    identities: 'รู้จักผ่านช่องทาง',
    aiNoted: 'สิ่งที่ AI บันทึกไว้',
    summary: 'สรุปบทสนทนาที่ผ่านมา',
    cost: 'ค่าใช้จ่าย',
    lastTrace: 'การทำงานล่าสุดของ AI',
    fallbackUsed: 'ใช้ผู้ให้บริการสำรอง',
    viewTrace: 'ดูรายละเอียด',
    owner: 'ผู้ดูแลลูกค้า',
    unassigned: 'ยังไม่มีผู้ดูแล',
    ownedBy: 'ดูแลโดย',
    mine: 'ของฉัน',
  },
  merge: {
    title: 'อาจเป็นคนเดียวกัน',
    hint: 'ทั้งสองรายการให้ข้อมูลเดียวกัน เมื่อรวมแล้วย้อนกลับไม่ได้',
    matchedOn: 'ตรงกันที่',
    keeps: 'เก็บรายการนี้ไว้',
    absorbs: 'รวมรายการนี้เข้าไป',
    conversations: 'บทสนทนา',
    accept: 'ใช่ คนเดียวกัน',
    reject: 'ไม่ใช่ คนละคน',
    confirm: 'ยืนยันการรวม',
    merging: 'กำลังรวม...',
    merged: 'รวมข้อมูลลูกค้าแล้ว',
    keys: {
      phone: 'เบอร์โทร',
      email: 'อีเมล',
      account_id: 'รหัสบัญชี',
    },
  },
  feedback: {
    up: 'ตอบดี',
    down: 'ตอบไม่ดี',
    why: 'ไม่ดีตรงไหน',
    notePlaceholder: 'รายละเอียดเพิ่มเติม (ไม่บังคับ)',
    save: 'บันทึก',
    skip: 'ข้าม',
    saved: 'บันทึกความเห็นแล้ว',
    reasons: {
      wrong_answer: 'ตอบผิด',
      fabricated: 'แต่งข้อมูลขึ้นเอง',
      missing_knowledge: 'ไม่มีข้อมูลเรื่องนี้ในคลังความรู้',
      wrong_tone_or_language: 'น้ำเสียงหรือภาษาไม่เหมาะ',
      should_have_handed_off: 'ควรส่งต่อให้เจ้าหน้าที่',
    },
  },
  knowledge: {
    indexing: 'กำลังทำดัชนี AI ยังค้นคำตอบใหม่นี้ไม่เจอ',
    ready: 'AI ค้นเจอแล้ว',
    readOnly: 'คุณดูคลังความรู้ได้อย่างเดียว การเพิ่มหรือแก้ไขต้องใช้สิทธิ์เจ้าหน้าที่',
    loadFailed: 'โหลดคลังความรู้ไม่สำเร็จ',
    entryConflict: 'มีคนอื่นแก้ไขรายการนี้หลังจากที่คุณเปิด ช่องนี้แสดงฉบับล่าสุดแล้ว กรุณาแก้ไขอีกครั้ง',
    searchFailed: 'ค้นหาไม่สำเร็จ',
    resultsFor: 'ผลการค้นหา "{{query}}"',
    howItScored: 'ดูคะแนนการค้นหาแต่ละแบบ',
    title: 'คลังความรู้',
    sources: 'แหล่งความรู้',
    add: 'เพิ่มความรู้',
    question: 'คำถาม',
    questionPlaceholder: 'เช่น ราคาแพ็กเกจเท่าไหร่',
    answer: 'คำตอบ',
    answerPlaceholder: 'คำตอบที่ต้องการให้ AI ใช้',
    save: 'บันทึก',
    uploadFile: 'อัปโหลดไฟล์',
    formats: 'PDF, DOCX, XLSX, CSV, TXT, MD',
    untitled: 'ไม่มีชื่อ',
    empty: 'ยังไม่มีความรู้',
    emptyHint: 'เพิ่มคำถามคำตอบ หรืออัปโหลดเอกสาร เพื่อให้ AI ตอบได้ตรงขึ้น',
    chunks: 'ชิ้น',
    reindex: 'จัดทำดัชนีใหม่',
    enabled: 'เปิดใช้งาน',
    testSearch: 'ทดสอบการค้นหา',
    testSearchPlaceholder: 'พิมพ์คำถามเหมือนลูกค้า',
    search: 'ค้นหา',
    fused: 'ผลรวม',
    denseHalf: 'ค้นตามความหมาย',
    keywordHalf: 'ค้นตามคำ',
    noHits: 'ไม่พบ',
    embeddingModel: 'โมเดล embedding',
    noEmbeddingModel: 'ยังไม่ได้ตั้งค่าโมเดล embedding จึงค้นได้เฉพาะตามคำ',
    saveAsKnowledge: 'บันทึกเป็นความรู้',
    promoteHint: 'ตรวจสอบและแก้ไขก่อนบันทึก ข้อความอาจมีชื่อหรือเลขออร์เดอร์ของลูกค้ารายนี้',
    status: {
      pending: 'รอดำเนินการ',
      processing: 'กำลังประมวลผล',
      ready: 'พร้อมใช้',
      failed: 'ไม่สำเร็จ',
    },
  },
  trace: {
    title: 'บันทึกการทำงานของ AI',
    knowledge: 'ความรู้ที่ใช้',
    tools: 'เครื่องมือที่เรียก',
    toolOutput: 'ผลลัพธ์',
    systemPrompt: 'คำสั่งระบบ',
    messages: 'บทสนทนาที่ส่งให้โมเดล',
  },
  setup: {
    title: 'ตั้งค่าให้พร้อมตอบลูกค้า',
    steps: {
      model: 'เลือกผู้ให้บริการและรุ่น AI สำหรับตอบลูกค้า',
      channel: 'เชื่อมต่อช่องทาง LINE, Messenger หรือวิดเจ็ต',
      knowledge: 'เพิ่มความรู้ให้ AI',
      tryIt: 'ลองส่งข้อความทดสอบ แล้วเปิดบทสนทนาดู',
    },
    optional: 'ไม่บังคับ',
    go: 'ไปตั้งค่า',
    done: 'เสร็จแล้ว',
    todo: 'ยังไม่ได้ทำ',
  },
  simulator: {
    openConversation: 'เปิดบทสนทนานี้',
    title: 'ทดลองแชท',
    description: 'ส่งข้อความเหมือนเป็นลูกค้า เพื่อทดสอบ AI โดยไม่ต้องใช้ LINE หรือ Facebook',
    customerName: 'ชื่อลูกค้า',
    customerId: 'รหัสลูกค้า',
    send: 'ส่งข้อความ',
    attachImage: 'แนบรูปภาพ',
    noChannel: 'ยังไม่มีช่องทางทดสอบ',
    sentCount: 'ส่งแล้ว {{count}} ข้อความ',
  },
  push: {
    title: 'การแจ้งเตือนบนอุปกรณ์นี้',
    hint: 'แจ้งเตือนเมื่อลูกค้ารอพนักงาน หรือเขียนมาในแชทที่คุณดูแล แม้ปิดหน้านี้อยู่',
    enable: 'เปิดการแจ้งเตือน',
    disable: 'ปิดบนอุปกรณ์นี้',
    on: 'เปิดอยู่บนอุปกรณ์นี้',
    sendTest: 'ส่งทดสอบ',
    needsInstall:
      'บน iPhone และ iPad ต้องเพิ่มหน้านี้ไปยังหน้าจอโฮมก่อน: แตะปุ่มแชร์ แล้วเลือก "เพิ่มไปยังหน้าจอโฮม" จากนั้นเปิดจากไอคอนนั้นและกลับมาที่หน้านี้',
    unsupported: 'เบราว์เซอร์นี้ไม่รองรับการแจ้งเตือน ลองใช้ Chrome หรือ Safari',
    denied: 'การแจ้งเตือนถูกบล็อกสำหรับเว็บไซต์นี้ เปิดได้จากการตั้งค่าของเบราว์เซอร์หรือของเครื่อง แล้วโหลดหน้านี้ใหม่',
    checkFailed: 'ตรวจสอบสถานะการแจ้งเตือนไม่สำเร็จ',
    test: {
      sent: 'ส่งแล้ว ควรเห็นการแจ้งเตือนในไม่กี่วินาที',
      not_subscribed: 'อุปกรณ์นี้ยังไม่ได้เปิดการแจ้งเตือน',
      gone: 'อุปกรณ์นี้ยกเลิกการรับแจ้งเตือนไปแล้ว กรุณาเปิดใหม่',
      failed: 'ส่งไม่สำเร็จ ลองอีกครั้งภายหลัง',
    },
  },
  settings: {
    readOnly: 'การตั้งค่าเป็นของผู้ดูแลพื้นที่ทำงาน คุณดูได้อย่างเดียว',
    loadFailed: 'โหลดการตั้งค่าไม่สำเร็จ',
    conflict: 'มีคนอื่นแก้ไขการตั้งค่านี้หลังจากที่คุณเปิดหน้า หน้านี้แสดงฉบับล่าสุดแล้ว กรุณาแก้ไขอีกครั้ง',
    title: 'ตั้งค่า',
    tabs: {
      general: 'ทั่วไป',
      channels: 'ช่องทาง',
      models: 'รุ่น AI',
      integrations: 'เชื่อมต่อระบบ',
    },
    workspace: 'พื้นที่ทำงาน',
    providers: 'ผู้ให้บริการ AI',
    taskSlots: 'รุ่นที่ใช้ในแต่ละงาน',
    tasks: {
      agent_chat: { label: 'ตอบลูกค้า', purpose: 'ใช้ตอบทุกข้อความ ถ้าไม่ตั้งค่า AI จะส่งต่อให้คนทันที' },
      vision: { label: 'อ่านรูปภาพ', purpose: 'อธิบายรูปที่ลูกค้าส่งมา ถ้าไม่ตั้งค่าจะส่งต่อให้คน' },
      suggestion_for_human: { label: 'ร่างให้เจ้าหน้าที่', purpose: 'ร่างคำตอบในแถบข้างให้เจ้าหน้าที่เลือกใช้' },
      summarize: { label: 'สรุปบทสนทนา', purpose: 'สรุปเมื่อปิดบทสนทนา เพื่อจำลูกค้าไว้ครั้งหน้า' },
      classify_intent_and_handoff: {
        label: 'จัดหมวดและตัดสินใจส่งต่อ',
        purpose: 'ตั้งค่าได้ แต่ยังไม่มีส่วนใดเรียกใช้',
      },
      embed: { label: 'ค้นคลังความรู้', purpose: 'ถ้าไม่ตั้งค่า จะค้นได้เฉพาะตามคำเท่านั้น' },
      rerank: { label: 'จัดอันดับผลค้นหา', purpose: 'ไม่บังคับ ช่วยให้เลือกความรู้ได้ตรงขึ้น' },
    },
    channels: 'ช่องทาง',
    members: 'ผู้ใช้งาน',
    persona: 'บุคลิกและคำสั่งของ AI',
    defaultMode: 'โหมดเริ่มต้น',
    defaultLanguage: 'ภาษาเริ่มต้น',
    redaction: 'การปกปิดข้อมูล',
    holdingMessages: 'ข้อความระหว่างรอเจ้าหน้าที่',
    holdingHint: 'ข้อความสองประโยคที่ระบบส่งเอง ไม่ใช่ AI เขียน ส่งตามภาษาที่ลูกค้าพิมพ์มา',
    acknowledgementText: 'ส่งทันทีเมื่อ AI ส่งต่อให้คน',
    stillWaitingText: 'ส่งเมื่อรอจนครบเวลาแล้วยังไม่มีใครรับ',
    waitingHumanFallback: 'รอได้นานกี่นาทีก่อนส่งข้อความขอโทษ',
    waitingHumanFallbackOff: 'เว้นว่างเพื่อไม่ส่ง',
    waitingHumanFallbackHint: 'เว้นว่างไว้ ระบบจะไม่ส่งข้อความที่สอง',
    autoResolve: 'ปิดบทสนทนาอัตโนมัติ',
    autoResolveHint:
      'ปิดบทสนทนาที่ AI ดูแลอยู่ (รวมถึงโหมด AI ร่าง) เมื่อฝั่งเราตอบล่าสุดแล้วลูกค้าเงียบไป รวมถึงบทสนทนาที่เจ้าหน้าที่ส่งคืนให้ AI แล้ว ไม่ปิดบทสนทนาที่รอเจ้าหน้าที่หรือเจ้าหน้าที่ดูแลอยู่ ถ้าลูกค้าพิมพ์มาใหม่จะเปิดอีกครั้งเอง',
    autoResolveHours: 'ปิดเมื่อลูกค้าเงียบไป (ชั่วโมง)',
    autoResolveOff: 'เว้นว่างเพื่อปิดการทำงาน',
    autoResolveOffHint: 'เว้นว่างไว้ จะไม่ปิดบทสนทนาอัตโนมัติ',
    autoResolveInvalid: 'ใส่จำนวนชั่วโมงเต็มระหว่าง 1 ถึง 720 หรือเว้นว่างไว้ ค่านี้ยังไม่ได้บันทึก',
    cardNumbers: 'เลขบัตรเครดิต',
    thaiNationalId: 'เลขบัตรประชาชน',
    save: 'บันทึก',
    saved: 'บันทึกแล้ว',
    saveFailed: 'บันทึกไม่สำเร็จ',
    addProvider: 'เพิ่มผู้ให้บริการ',
    name: 'ชื่อ',
    baseUrl: 'ที่อยู่ API',
    apiKey: 'คีย์ API',
    keySet: 'ตั้งค่าคีย์แล้ว',
    primary: 'หลัก',
    fallback: 'สำรอง',
    model: 'รุ่น',
    pickProviderFirst: 'เลือกผู้ให้บริการก่อน',
    refreshModels: 'โหลดรายการรุ่นใหม่',
    loadingModels: 'กำลังโหลดรายการรุ่น...',
    noModelList: 'ไม่มีรายการรุ่นจากผู้ให้บริการนี้ พิมพ์ชื่อรุ่นเองได้',
    typeModelIn: 'พิมพ์ชื่อรุ่นเอง...',
    backToList: 'รายการ',
    unlisted: 'ไม่อยู่ในรายการ',
    verify: 'ทดสอบ',
    verifying: 'กำลังทดสอบ...',
    verifyOk: 'ใช้งานได้',
    verifyFailed: 'ใช้ไม่ได้',
    sendDimensions: 'ส่งค่า dimensions ไปกับคำขอ embedding',
    sendDimensionsHint:
      'ปิดได้ถ้าผู้ให้บริการไม่รับค่านี้ โมเดลจะตอบกลับด้วยขนาดมาตรฐานของตัวเอง ระบบยังตรวจขนาดให้อยู่',
    none: 'ไม่ใช้',
    webhookUrl: 'ที่อยู่ Webhook',
    connectLine: 'เชื่อมต่อ LINE',
    connectMessenger: 'เชื่อมต่อ Messenger',
    connectHint: 'สร้างช่องทางก่อน แล้วนำที่อยู่ Webhook ไปตั้งค่าในแพลตฟอร์ม จากนั้นจึงวางคีย์กลับมาที่นี่',
    configure: 'ตั้งค่า',
    credentialsSet: 'ตั้งค่าคีย์แล้ว',
    credentialsMissing: 'ยังไม่มีคีย์',
    checkConnection: 'ทดสอบการเชื่อมต่อ',
    verifyToken: 'Verify token',
    webhookHint: 'นำที่อยู่นี้ไปใส่ในหน้าตั้งค่า Webhook ของแพลตฟอร์ม',
    unchanged: 'ไม่เปลี่ยนแปลง',
    embedSnippet: 'โค้ดสำหรับฝังในเว็บไซต์',
    embedHint: 'วางโค้ดนี้ก่อนปิด </body> ในเว็บไซต์ของคุณ',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    allowedOrigins: 'โดเมนที่อนุญาตให้ฝัง',
    originsHint: 'ใส่ได้หลายโดเมน คั่นด้วยเว้นวรรคหรือจุลภาค',
    originsOpen: 'ยังไม่จำกัดโดเมน เว็บไซต์ใดก็ฝังได้ ควรกำหนดก่อนใช้งานจริง',
    previewWidget: 'ดูตัวอย่างวิดเจ็ต',
    cannedResponses: 'ข้อความสำเร็จรูป',
    cannedHint: 'พิมพ์ /ชื่อย่อ แล้วเว้นวรรคในช่องพิมพ์ ข้อความจะถูกแทนที่ทันที',
    shortcut: 'ชื่อย่อ',
    cannedBody: 'ข้อความ',
    addCanned: 'เพิ่มข้อความสำเร็จรูป',
    tools: 'เครื่องมือของคุณ',
    toolsHint: 'ให้ AI เรียก API ของคุณเองได้ เช่น ตรวจสอบแพ็กเกจหรือยกเลิกการจอง เฉพาะผู้ดูแลเท่านั้น',
    toolName: 'ชื่อเครื่องมือ',
    toolNameHint: 'ตัวพิมพ์เล็ก ตัวเลข และขีดล่าง เช่น check_plan',
    toolDescription: 'อธิบายให้ AI รู้ว่าใช้เมื่อไหร่',
    toolUrl: 'URL',
    // The braces are the thing being explained, so they arrive as a value rather than
    // being written into the sentence, where i18next would read them as its own and
    // substitute an empty string for a variable nobody passed.
    toolUrlHint: 'ใส่ {{placeholder}} ในเส้นทางเพื่อแทนค่าอาร์กิวเมนต์หรือค่าที่ระบบผูกให้',
    toolMethod: 'เมธอด',
    toolEffect: 'ชนิด',
    toolEffectRead: 'อ่านอย่างเดียว',
    toolEffectWrite: 'เขียนข้อมูล',
    toolEffectHint: 'เครื่องมือที่เขียนข้อมูลจะทำงานหลังจบรอบสนทนา และถ้าล้มเหลวจะไม่ส่งคำตอบให้ลูกค้า',
    toolAuth: 'การยืนยันตัวตน',
    toolAuthNone: 'ไม่มี',
    toolAuthBearer: 'Bearer token',
    toolAuthHeader: 'ส่งใน header',
    toolAuthHeaderName: 'ชื่อ header',
    toolCredential: 'ข้อมูลลับ',
    toolCredentialSet: 'บันทึกข้อมูลลับแล้ว',
    toolTimeout: 'หมดเวลา (มิลลิวินาที)',
    toolArgs: 'อาร์กิวเมนต์ที่ AI กรอกเอง',
    toolArgsHint: 'AI จะเลือกค่าพวกนี้เอง จึงไม่ควรใส่ข้อมูลที่ระบุตัวบุคคล',
    toolArgName: 'ชื่อ',
    toolArgType: 'ชนิด',
    toolArgDescription: 'คำอธิบาย',
    toolArgRequired: 'จำเป็น',
    addArg: 'เพิ่มอาร์กิวเมนต์',
    toolBindings: 'ค่าที่ระบบผูกให้',
    toolBindingsHint:
      'ระบบเป็นผู้ใส่ค่าเหล่านี้ AI มองไม่เห็นและแก้ไม่ได้ ผูกกับบัญชีที่ยืนยันแล้วได้เฉพาะบทสนทนาที่ยืนยันตัวตนสำเร็จ',
    bindingSubject: 'บัญชีที่ยืนยันแล้ว',
    bindingCustomer: 'รหัสลูกค้า',
    bindingConversation: 'รหัสบทสนทนา',
    bindingWorkspace: 'รหัสพื้นที่ทำงาน',
    addTool: 'เพิ่มเครื่องมือ',
    saveTool: 'บันทึก',
    testTool: 'ทดสอบ',
    testSubject: 'บัญชีที่ใช้ทดสอบ',
    toolNoTools: 'ยังไม่มีเครื่องมือ',
    identity: 'การยืนยันตัวตน',
    identityHint:
      'เครื่องมือที่อ่านข้อมูลบัญชีจะถูกเสนอให้ AI เฉพาะเมื่อพิสูจน์ตัวตนลูกค้าได้แล้ว ปิดสวิตช์ใดก็ตาม เครื่องมือที่ผูกกับวิธีนั้นจะหายไปทันที',
    identityWidgetToken: 'โทเค็นจากเว็บไซต์ของคุณ (วิดเจ็ต)',
    identityWidgetTokenHint: 'แอปของคุณเซ็นโทเค็นให้ผู้ใช้ที่ล็อกอินอยู่ แล้ววิดเจ็ตส่งมาให้เรา',
    identityLink: 'ลิงก์ยืนยันตัวตนครั้งเดียว (LINE / Messenger)',
    identityLinkHint: 'เราส่งลิงก์ให้ลูกค้า แอปของคุณให้เขาล็อกอิน แล้วส่งผลกลับมา',
    identityLinkUrl: 'URL หน้ายืนยันของคุณ',
    identityLinkSecret: 'ข้อมูลลับสำหรับเซ็นโทเค็น',
    identityLinkTtl: 'อายุลิงก์ (นาที)',
  },
  admin: {
    loadFailed: 'โหลดรายชื่อสมาชิกไม่สำเร็จ',
    title: 'ผู้ใช้งานในพื้นที่ทำงานนี้',
    hint: 'เชิญเพื่อนร่วมงาน กำหนดสิทธิ์ และออกลิงก์ตั้งรหัสผ่านใหม่',
    members: 'สมาชิก',
    invitations: 'คำเชิญที่รออยู่',
    email: 'อีเมล',
    role: 'สิทธิ์',
    roles: { admin: 'ผู้ดูแล', agent: 'เจ้าหน้าที่', viewer: 'ผู้ดูอย่างเดียว' },
    invite: 'เชิญ',
    inviteHint: 'ระบบไม่ส่งอีเมล กรุณาคัดลอกลิงก์แล้วส่งให้เพื่อนร่วมงานเอง',
    linkOnce: 'ลิงก์นี้แสดงเพียงครั้งเดียว',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    remove: 'นำออก',
    removeConfirm: 'กดอีกครั้งเพื่อนำออก',
    resetLink: 'ลิงก์ตั้งรหัสผ่านใหม่',
    revoke: 'ยกเลิกคำเชิญ',
    expires: 'หมดอายุ',
    invitedBy: 'เชิญโดย',
    self: 'คุณ',
    demoteSelfConfirm: 'ลดสิทธิ์ของตัวเองใช่หรือไม่ คุณจะเข้าหน้านี้ไม่ได้อีกและต้องให้ผู้ดูแลคนอื่นคืนสิทธิ์ให้',
    noInvitations: 'ไม่มีคำเชิญที่รออยู่',
  },
  platform: {
    loadFailed: 'โหลดข้อมูลพื้นที่ทำงานไม่สำเร็จ',
    title: 'พื้นที่ทำงานทั้งหมด',
    hint: 'สร้าง ระงับ หรือลบพื้นที่ทำงานของลูกค้าแต่ละราย',
    tenants: 'พื้นที่ทำงาน',
    create: 'สร้างพื้นที่ทำงาน',
    name: 'ชื่อ',
    slug: 'ชื่อย่อ (ใช้ใน URL)',
    adminEmail: 'อีเมลผู้ดูแลคนแรก',
    members: 'สมาชิก',
    statuses: { active: 'ใช้งานอยู่', suspended: 'ถูกระงับ', deleting: 'กำลังลบ' },
    suspend: 'ระงับ',
    suspendConfirm: 'กดอีกครั้งเพื่อระงับ',
    unsuspend: 'เปิดใช้งานอีกครั้ง',
    delete: 'ลบถาวร',
    deleteHint: 'ลบทุกอย่างอย่างถาวร กู้คืนไม่ได้ พิมพ์ชื่อย่อเพื่อยืนยัน',
    typeSlug: 'พิมพ์ชื่อย่อเพื่อยืนยัน',
    admins: 'ผู้ดูแลระบบ',
    adminsHint: 'ผู้ที่จัดการพื้นที่ทำงานได้ ต้องมีบัญชีอยู่แล้ว',
    grant: 'ให้สิทธิ์',
    revokeAdmin: 'ถอนสิทธิ์',
    grantedBySeed: 'ตั้งค่าเริ่มต้นของระบบ',
    recovery: 'กู้คืนบัญชี',
    recoveryHint:
      'ออกลิงก์ตั้งรหัสผ่านใหม่ให้บัญชีที่ผู้ดูแลพื้นที่ทำงานออกให้ไม่ได้ คือบัญชีที่อยู่มากกว่าหนึ่งพื้นที่ทำงาน หรือเป็นผู้ดูแลระบบ',
    issueReset: 'ออกลิงก์',
    egress: 'ที่อยู่ภายในที่อนุญาต',
    egressHint:
      'ที่อยู่ส่วนตัวหรือ http ที่ผู้ให้บริการ AI และระบบค้นคืนภายนอกของพื้นที่ทำงานนี้เรียกได้ เช่น gateway ในเครือข่ายของคุณ บรรทัดละหนึ่งที่อยู่ ผู้ดูแลพื้นที่ทำงานตั้งเองไม่ได้',
    egressNone: 'ไม่มี',
    egressEdit: 'แก้ไข',
  },
  invite: {
    unreachable: 'ติดต่อเซิร์ฟเวอร์ไม่ได้ ลิงก์อาจยังใช้ได้ ลองใหม่อีกครั้ง',
    joinTitle: 'เข้าร่วม',
    resetTitle: 'ตั้งรหัสผ่านใหม่',
    name: 'ชื่อของคุณ',
    password: 'รหัสผ่าน',
    passwordHint: 'อย่างน้อย 8 ตัวอักษร',
    needName: 'กรุณากรอกชื่อของคุณ',
    accept: 'เข้าร่วม',
    join: 'เข้าร่วมพื้นที่ทำงานนี้',
    signInFirst: 'บัญชีนี้มีอยู่แล้ว กรุณาเข้าสู่ระบบก่อนเพื่อรับคำเชิญ',
    signIn: 'เข้าสู่ระบบ',
    invalid: 'ลิงก์นี้ใช้ไม่ได้แล้ว',
    invalidHint: 'ลิงก์อาจถูกใช้ไปแล้ว หมดอายุ หรือถูกยกเลิก กรุณาขอลิงก์ใหม่',
    issuedTo: 'ลิงก์นี้ออกให้กับ',
  },
  workspace: {
    suspended: 'พื้นที่ทำงานนี้ถูกระงับ',
    suspendedHint: 'กรุณาติดต่อผู้ดูแลระบบ ข้อมูลทั้งหมดยังอยู่ครบ',
    deleting: 'พื้นที่ทำงานนี้กำลังถูกลบ',
    deletingHint: 'ข้อมูลกำลังถูกลบอย่างถาวร',
    none: 'บัญชีของคุณยังไม่อยู่ในพื้นที่ทำงานใด',
    noneHint: 'กรุณาขอคำเชิญจากผู้ดูแล',
    switch: 'เปลี่ยนพื้นที่ทำงาน',
  },
  notFound: {
    title: 'ไม่พบหน้านี้',
    hint: 'ที่อยู่อาจพิมพ์ผิด หรือหน้านี้ถูกย้ายไปแล้ว',
    backToInbox: 'กลับไปที่กล่องข้อความ',
    noWorkspace: 'ไม่พบพื้นที่ทำงานนี้',
    noWorkspaceHint: 'อาจสะกดผิด หรือบัญชีของคุณไม่ได้อยู่ในพื้นที่ทำงานนี้',
    switching: 'กำลังเปลี่ยนพื้นที่ทำงาน...',
  },
  channels: {
    line: 'LINE',
    messenger: 'Messenger',
    web: 'เว็บไซต์',
    test: 'ทดลอง',
  },
  common: {
    loading: 'กำลังโหลด...',
    saving: 'กำลังบันทึก...',
    error: 'เกิดข้อผิดพลาด',
    retry: 'ลองใหม่',
    edit: 'แก้ไข',
    remove: 'นำออก',
    removeConfirm: 'กดอีกครั้งเพื่อลบ',
    cancel: 'ยกเลิก',
    close: 'ปิด',
    save: 'บันทึก',
    you: 'คุณ',
    ai: 'AI',
    customer: 'ลูกค้า',
    system: 'ระบบ',
  },
}

const en: typeof th = {
  app: {
    name: 'AI Chat Desk',
    signOut: 'Sign out',
    reconnecting: 'Reconnecting — this page may be behind',
    disconnected: 'Disconnected',
  },
  nav: {
    inbox: 'Inbox',
    dashboard: 'Overview',
    knowledge: 'Knowledge',
    simulator: 'Simulator',
    settings: 'Settings',
    admin: 'People',
    platform: 'Platform',
    more: 'More',
    openCount: '{{count}} open conversations',
    waitingCount: '{{count}} waiting for a person',
  },
  auth: {
    title: 'Sign in',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    failed: 'Sign in failed',
    unreachable: 'Could not reach the server. Try again.',
    forgotHint: 'Forgotten your password? Ask your workspace admin for a reset link.',
  },
  dashboard: {
    whatIsCounted: 'What is counted',
    inTimezone: 'Days in {{timezone}}',
    definitions: {
      conversations:
        'Conversations started in the window, and customer messages received in it, by the workspace’s own days.',
      answered:
        'Share of AI turns whose reply actually reached the customer, out of turns the AI answered or handed to a person. Replies that failed, or were withheld because a colleague took over, do not count.',
      handoffWait:
        'Median time from the AI handing over to a colleague’s reply reaching the customer; handoffs nobody has answered yet are shown beside it. First response is from a customer’s first message to the first reply that was delivered.',
      cost: 'An estimate from the model prices you set. Covers answers and image reading; knowledge search and attempts that failed before a fallback are not included.',
    },
    title: 'Overview',
    days: 'days',
    conversations: 'Conversations',
    customerMessages: 'messages from customers',
    answeredShare: 'Answered by the AI',
    turns: 'turns',
    firstResponse: 'first reply',
    handoffWait: 'Wait for a person (median)',
    handoffs: 'handoffs',
    noneAnswered: 'Nobody has picked up a handoff yet',
    stillUnanswered: '{{count}} still unanswered',
    peak: 'peak',
    tokens: 'tokens',
    notPriced: 'Not priced',
    volumeSummary: '{{total}} conversations over {{days}} days, peaking at {{peak}} in a day',
    cost: 'Estimated cost',
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    volume: 'Conversation volume',
    handoffReasons: 'Why it handed off',
    handoffHint: 'This is the list of what to write into the knowledge base next.',
    noHandoffs: 'Nothing handed off yet',
    channels: 'Channels',
    noTraffic: 'No conversations yet',
    waitingNow: 'conversations are waiting for a person right now',
    feedback: 'Feedback on AI replies',
    feedbackUp: 'Good',
    feedbackDown: 'Bad',
    downReasons: 'Why replies were marked bad',
    noFeedback: 'Nobody has rated a reply yet',
    feedbackHint: 'These reasons say what to fix first.',
    reviewQueueNow: 'conversations the AI handled that nobody has reviewed',
  },
  inbox: {
    loadFailed: 'The conversations could not be loaded',
    loadMore: 'Load more',
    search: 'Search names, phone numbers, tags or messages',
    noMatches: 'No conversations on this tab match',
    image: 'Image',
    deliveryQueued: 'Waiting to send',
    deliverySent: 'Sent',
    deliveryDelivered: 'Delivered',
    deliveryRead: 'Read',
    deliveryFailed: 'Not delivered',
    resend: 'Send again',
    resending: 'Sending…',
    deliveryCanceled: 'Not sent: a colleague took over first',
    deliveryUncertain: 'Delivery uncertain',
    deliveryUncertainHint:
      'The platform did not answer, so this may have arrived. It is not resent automatically; check before sending again',
    openImage: 'Open in new tab',
    title: 'Inbox',
    empty: 'No conversations yet',
    waiting: 'Waiting for a human',
    review: 'Review',
    filters: { all: 'All', open: 'Open', resolved: 'Resolved', unassigned: 'Unassigned' },
    searchPlaceholder: 'Search',
  },
  mcp: {
    title: 'MCP servers',
    hint: 'Connect your own MCP server and choose which of its tools the AI may use. Unticked tools are never offered, and every tool says whether it only reads or changes something.',
    none: 'No servers connected',
    loadFailed: 'The MCP servers could not be loaded',
    add: 'Connect a server',
    name: 'Name (prefixes its tool names)',
    url: 'Server URL',
    auth: 'Authentication',
    authHeader: 'Token in a header',
    authOAuth: 'Sign in (OAuth)',
    oauthWarning:
      'The AI calls this server as the account that signs in, for every customer. Use an account made for the purpose, not a personal one.',
    signIn: 'Sign in',
    signInAgain: 'Sign in again',
    signedIn: 'Signed in',
    notSignedIn: 'Not signed in',
    signedInNow: 'Signed in to the MCP server',
    signInFailed: 'Signing in to the MCP server did not work. Try again.',
    disconnect: 'Sign out',
    authNone: 'None',
    headerName: 'Header name',
    token: 'Token (stored encrypted, never shown again)',
    connect: 'Connect',
    enabled: 'Enabled',
    allowedCount: '{{count}} allowed',
    needsReconnect: 'Sign in again',
    fetch: 'Fetch its tools',
    refetch: 'Fetch again',
    cost: 'Adds about {{tokens}} tokens to every conversation',
    tooLarge: 'This tool describes itself too largely to offer to the AI',
    effect: 'What the tool does',
    chooseEffect: 'Choose read or write',
    binding: 'Value of {{name}}',
    modelFills: 'The AI fills it',
    saveAllowed: 'Save allowed tools',
    undecided: 'Some ticked tools still need read or write chosen',
    test: 'Test a tool',
    testArgs: 'Arguments (JSON)',
    testRun: 'Run',
    testWrites: 'This tool writes: testing it changes real data in your system.',
  },
  tags: {
    label: 'Tags',
    add: 'Add tag',
    remove: 'Remove tag {{tag}}',
    filter: 'Filter by tag',
    filterBy: 'Show only {{tag}}',
    removeFilter: 'Stop filtering by {{tag}}',
    clearFilter: 'Clear all',
    cardTitle: 'Tags',
    cardHint:
      'Every tag in this workspace. Rename one to a tag that already exists to merge them; deleting removes it from every conversation.',
    empty: 'No tags yet',
    loadFailed: 'The tags could not be loaded',
    used: '{{count}} conversations',
    rename: 'Rename',
    newName: 'New name',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete everywhere',
    confirmDelete: 'Confirm delete',
    topTitle: 'Most used tags',
    topDefinition:
      'Conversations with a message in this period, by tag, and how many of them were handed to a person in the same period.',
    topHandoffs: '{{count}} handed off',
    noTags: 'No tagged conversations in this period',
  },
  modes: {
    ai: 'AI',
    ai_supervised: 'AI drafts',
    human: 'Human',
    waiting_human: 'Waiting',
  },
  conversation: {
    notAvailable:
      'This conversation cannot be opened. It may have been deleted, or you may not have access.',
    loadFailed: 'The conversation could not be loaded',
    sendFailed: 'The reply was not sent; it is still in the box',
    newMessages: 'New messages',
    readOnly: 'You can read this conversation. Replying needs an agent role.',
    takeOver: 'Take over',
    returnToAi: 'Return to AI',
    returnNote: 'Note for the AI (optional)',
    placeholder: 'Write a message...',
    send: 'Send',
    internalNote: 'Internal note',
    addNote: 'Add note',
    resolve: 'Resolve',
    reopen: 'Reopen',
    noMessages: 'No messages yet',
    handoffReason: 'Handoff reason',
    handoffReasons: {
      ai_requested: 'The AI asked for a person',
      customer_requested: 'The customer asked for a person',
      low_confidence: 'The AI was not sure',
      negative_sentiment: 'The customer was unhappy',
      keyword_rule: 'Matched a handoff keyword',
      unsupported_media: 'A file the AI cannot read',
      tool_error: 'A tool failed',
      model_error: 'The model could not be reached',
    },
    selectPrompt: 'Choose a conversation to start',
    loadOlder: 'Show earlier messages',
    backToList: 'Back to the list',
    attach: 'Attach',
  },
  sidebar: {
    identityVerified: 'Verified',
    identityUnverified: 'Not verified',
    identityVia: { widget_token: 'via your site', verification_link: 'via a link' },
    sendVerificationLink: 'Send a verification link',
    verificationLinkSent: 'Link sent',
    erase: 'Delete this customer',
    eraseConfirm: 'Confirm permanent deletion',
    eraseWho: 'Erase everything about {{name}}?',
    erasing: 'Deleting...',
    eraseQueued: 'Deletion queued. Everything of theirs will be removed.',
    eraseHint: 'Removes every conversation, image and detail for this customer. Cannot be undone.',
    review: 'Review',
    inReviewQueue: 'The AI handled this with nobody watching.',
    markReviewed: 'Mark reviewed',
    suggestion: 'Suggested reply',
    insert: 'Insert',
    insertAndSend: 'Insert and send',
    discard: 'Discard',
    noSuggestion: 'No suggestion yet',
    title: 'AI and customer',
    customer: 'Customer',
    fields: {
      phone: 'Phone',
      email: 'Email',
      order_id: 'Order id',
      account_id: 'Account id',
      company: 'Company',
    },
    identities: 'Known on',
    aiNoted: 'What the AI noted',
    summary: 'Summary of past conversations',
    cost: 'Cost',
    lastTrace: 'Last AI run',
    fallbackUsed: 'Fallback provider used',
    viewTrace: 'View details',
    owner: 'Account owner',
    unassigned: 'Nobody yet',
    ownedBy: 'Owner',
    mine: 'Yours',
  },
  merge: {
    title: 'Possibly the same person',
    hint: 'Both records gave the same detail. Merging cannot be undone.',
    matchedOn: 'Matched on',
    keeps: 'Kept',
    absorbs: 'Merged into it',
    conversations: 'conversations',
    accept: 'Yes, same person',
    reject: 'No, different people',
    confirm: 'Confirm merge',
    merging: 'Merging...',
    merged: 'The two records are now one',
    keys: {
      phone: 'phone',
      email: 'email',
      account_id: 'account id',
    },
  },
  feedback: {
    up: 'Good reply',
    down: 'Bad reply',
    why: 'What went wrong?',
    notePlaceholder: 'Anything to add (optional)',
    save: 'Save',
    skip: 'Skip',
    saved: 'Feedback saved',
    reasons: {
      wrong_answer: 'Wrong answer',
      fabricated: 'Made something up',
      missing_knowledge: 'Not in the knowledge base',
      wrong_tone_or_language: 'Wrong tone or language',
      should_have_handed_off: 'Should have handed off',
    },
  },
  knowledge: {
    indexing: 'Indexing — the AI cannot find this version yet',
    ready: 'Findable by the AI',
    readOnly: 'You can read the knowledge base. Adding or editing needs an agent role.',
    loadFailed: 'The knowledge base could not be loaded',
    entryConflict:
      'Somebody else changed this entry after you opened it. It now shows their version; make your change again.',
    searchFailed: 'The search failed',
    resultsFor: 'Results for "{{query}}"',
    howItScored: 'How each half of the search scored',
    title: 'Knowledge',
    sources: 'Sources',
    add: 'Add knowledge',
    question: 'Question',
    questionPlaceholder: 'For example, how much does the starter plan cost',
    answer: 'Answer',
    answerPlaceholder: 'The answer you want the AI to use',
    save: 'Save',
    uploadFile: 'Upload a file',
    formats: 'PDF, DOCX, XLSX, CSV, TXT, MD',
    untitled: 'Untitled',
    empty: 'No knowledge yet',
    emptyHint: 'Add a question and answer, or upload a document, so the AI can answer from facts.',
    chunks: 'chunks',
    reindex: 'Re-index',
    enabled: 'Enabled',
    testSearch: 'Test search',
    testSearchPlaceholder: 'Type a question the way a customer would',
    search: 'Search',
    fused: 'Combined',
    denseHalf: 'By meaning',
    keywordHalf: 'By words',
    noHits: 'Nothing found',
    embeddingModel: 'Embedding model',
    noEmbeddingModel: 'No embedding model configured, so only word search is available.',
    saveAsKnowledge: 'Save as knowledge',
    promoteHint: 'Review and edit before saving. The reply may name this customer or their order.',
    status: {
      pending: 'Pending',
      processing: 'Processing',
      ready: 'Ready',
      failed: 'Failed',
    },
  },
  trace: {
    title: 'AI run',
    knowledge: 'Knowledge used',
    tools: 'Tools called',
    toolOutput: 'answered',
    systemPrompt: 'System prompt',
    messages: 'Messages sent to the model',
  },
  setup: {
    title: 'Getting ready to answer customers',
    steps: {
      model: 'Choose a provider and model for answering',
      channel: 'Connect LINE, Messenger or the web widget',
      knowledge: 'Give the AI some knowledge',
      tryIt: 'Send a test message and open the conversation',
    },
    optional: 'optional',
    go: 'Set up',
    done: 'done',
    todo: 'not done yet',
  },
  simulator: {
    openConversation: 'Open this conversation',
    title: 'Simulator',
    description: 'Send messages as a customer to exercise the AI without LINE or Facebook.',
    customerName: 'Customer name',
    customerId: 'Customer id',
    send: 'Send message',
    attachImage: 'Attach image',
    noChannel: 'No test channel configured',
    sentCount: 'Sent {{count}}',
  },
  push: {
    title: 'Notifications on this device',
    hint: 'Get notified when a customer is waiting for a person or writes in a conversation you hold, even with this page closed.',
    enable: 'Turn on notifications',
    disable: 'Turn off on this device',
    on: 'On for this device',
    sendTest: 'Send a test',
    needsInstall:
      'On iPhone and iPad, add this page to your Home Screen first: tap Share, choose "Add to Home Screen", then open it from that icon and come back here.',
    unsupported: 'This browser cannot show notifications. Try Chrome or Safari.',
    denied:
      'Notifications are blocked for this site. Allow them in your browser or device settings, then reload this page.',
    checkFailed: 'Could not check the notification status.',
    test: {
      sent: 'Sent. It should appear within a few seconds.',
      not_subscribed: 'This device has not turned notifications on.',
      gone: 'This device is no longer subscribed. Please turn it on again.',
      failed: 'Could not send it. Try again later.',
    },
  },
  settings: {
    readOnly: 'Settings belong to workspace admins. You can read them here.',
    loadFailed: 'The settings could not be loaded',
    conflict:
      'Somebody else changed these settings after you opened the page. It now shows their version; make your change again.',
    title: 'Settings',
    tabs: {
      general: 'General',
      channels: 'Channels',
      models: 'AI models',
      integrations: 'Integrations',
    },
    workspace: 'Workspace',
    providers: 'AI providers',
    taskSlots: 'Model per task',
    tasks: {
      agent_chat: {
        label: 'Answering customers',
        purpose: 'Every reply. Without it the AI hands off immediately.',
      },
      vision: {
        label: 'Reading images',
        purpose: 'Describes pictures customers send. Without it they go to a person.',
      },
      suggestion_for_human: {
        label: 'Drafting for an agent',
        purpose: 'The suggested reply in the sidebar.',
      },
      summarize: {
        label: 'Summarising a conversation',
        purpose: 'Runs on resolve, so the next conversation remembers this one.',
      },
      classify_intent_and_handoff: {
        label: 'Classifying intent',
        purpose: 'Configurable, and nothing reads it yet.',
      },
      embed: {
        label: 'Searching the knowledge base',
        purpose: 'Without it only word search is available.',
      },
      rerank: { label: 'Ranking search results', purpose: 'Optional. Sharpens what is found.' },
    },
    channels: 'Channels',
    members: 'People',
    persona: 'AI persona and instructions',
    defaultMode: 'Default mode',
    defaultLanguage: 'Default language',
    redaction: 'Redaction',
    holdingMessages: 'What a customer reads while they wait',
    holdingHint:
      'Two sentences the system sends itself, not the AI, in whichever language the customer wrote in.',
    acknowledgementText: 'Sent the moment the AI fetches a person',
    stillWaitingText: 'Sent if nobody has picked the conversation up in time',
    waitingHumanFallback: 'Minutes to wait before apologising',
    waitingHumanFallbackOff: 'Leave empty to send nothing',
    waitingHumanFallbackHint: 'Leave this empty and the second message is never sent.',
    autoResolve: 'Closing quiet conversations',
    autoResolveHint:
      'Resolves a conversation the AI is answering once our side has spoken last and the customer has gone quiet, including one a colleague handed back to the AI. Never one that is waiting for a person or that a colleague owns. If the customer writes again it reopens.',
    autoResolveHours: 'Close after the customer is quiet for (hours)',
    autoResolveOff: 'Leave empty to switch off',
    autoResolveOffHint: 'Leave this empty and conversations are never closed automatically.',
    autoResolveInvalid:
      'Use a whole number of hours from 1 to 720, or leave it empty. This was not saved.',
    cardNumbers: 'Card numbers',
    thaiNationalId: 'Thai national ID',
    save: 'Save',
    saved: 'Saved',
    saveFailed: 'Not saved',
    addProvider: 'Add provider',
    name: 'Name',
    baseUrl: 'Base URL',
    apiKey: 'API key',
    keySet: 'Key is set',
    primary: 'Primary',
    fallback: 'Fallback',
    model: 'Model',
    pickProviderFirst: 'Pick a provider first',
    refreshModels: 'Reload model lists',
    loadingModels: 'Loading models...',
    noModelList: 'this provider serves no model list, so type the model id',
    typeModelIn: 'Type a model id...',
    backToList: 'List',
    unlisted: 'not listed',
    verify: 'Test',
    verifying: 'Testing...',
    verifyOk: 'Works',
    verifyFailed: 'Does not work',
    sendDimensions: 'Send the dimensions parameter with embedding requests',
    sendDimensionsHint:
      'Turn this off for a provider that rejects the field. The model then answers at its own native size, which is still checked.',
    none: 'None',
    webhookUrl: 'Webhook URL',
    connectLine: 'Connect LINE',
    connectMessenger: 'Connect Messenger',
    connectHint:
      'Create the channel first, put its webhook URL into the platform, then paste the keys back here.',
    configure: 'Configure',
    credentialsSet: 'Credentials set',
    credentialsMissing: 'No credentials',
    checkConnection: 'Check connection',
    verifyToken: 'Verify token',
    webhookHint: "Paste this into the platform's webhook settings.",
    unchanged: 'Unchanged',
    embedSnippet: 'Embed code',
    embedHint: 'Paste this before the closing </body> tag of your site.',
    copy: 'Copy',
    copied: 'Copied',
    allowedOrigins: 'Sites allowed to embed it',
    originsHint: 'Several are allowed, separated by spaces or commas.',
    originsOpen: 'Unrestricted: any site may embed it. Set this before going live.',
    previewWidget: 'Preview the widget',
    cannedResponses: 'Canned responses',
    cannedHint: 'Type /shortcut followed by a space in the composer and the text expands in place.',
    shortcut: 'Shortcut',
    cannedBody: 'Text',
    addCanned: 'Add canned response',
    tools: 'Your tools',
    toolsHint: 'Let the AI call your own API, to check a plan or cancel a booking. Admins only.',
    toolName: 'Tool name',
    toolNameHint: 'Lowercase letters, digits and underscores, such as check_plan.',
    toolDescription: 'Tell the AI when to use it',
    toolUrl: 'URL',
    toolUrlHint: 'Put {{placeholder}} in the path to substitute an argument or a bound value.',
    toolMethod: 'Method',
    toolEffect: 'Kind',
    toolEffectRead: 'Reads only',
    toolEffectWrite: 'Writes something',
    toolEffectHint:
      'A writing tool runs after the turn, and if it fails the reply is held back and a person is fetched.',
    toolAuth: 'Authentication',
    toolAuthNone: 'None',
    toolAuthBearer: 'Bearer token',
    toolAuthHeader: 'In a header',
    toolAuthHeaderName: 'Header name',
    toolCredential: 'Credential',
    toolCredentialSet: 'Credential is set',
    toolTimeout: 'Timeout (ms)',
    toolArgs: 'Arguments the AI fills in',
    toolArgsHint: 'The AI chooses these values, so nothing identifying a person belongs here.',
    toolArgName: 'Name',
    toolArgType: 'Type',
    toolArgDescription: 'Description',
    toolArgRequired: 'Required',
    addArg: 'Add argument',
    toolBindings: 'Values the system supplies',
    toolBindingsHint:
      'We fill these in. The AI cannot see or change them. A tool bound to a verified account is only offered once that account has been proved.',
    bindingSubject: 'Verified account',
    bindingCustomer: 'Customer id',
    bindingConversation: 'Conversation id',
    bindingWorkspace: 'Workspace id',
    addTool: 'Add tool',
    saveTool: 'Save',
    testTool: 'Test',
    testSubject: 'Account to test with',
    toolNoTools: 'No tools yet',
    identity: 'Proving who a customer is',
    identityHint:
      'Tools that read an account are only offered once the customer has been proved. Switching one off withdraws the tools bound to it straight away.',
    identityWidgetToken: 'Token from your site (widget)',
    identityWidgetTokenHint:
      'Your app signs a token for its logged-in user and the widget presents it.',
    identityLink: 'One-time verification link (LINE / Messenger)',
    identityLinkHint:
      'We send the customer a link, your app logs them in, and confirms it back to us.',
    identityLinkUrl: 'Your verification page URL',
    identityLinkSecret: 'Secret you sign the confirmation with',
    identityLinkTtl: 'Link lifetime (minutes)',
  },
  admin: {
    loadFailed: 'The members could not be loaded',
    title: 'People in this workspace',
    hint: 'Invite colleagues, set what they may do, and issue a link to reset a password.',
    members: 'Members',
    invitations: 'Pending invitations',
    email: 'Email',
    role: 'Role',
    roles: { admin: 'Admin', agent: 'Agent', viewer: 'Viewer' },
    invite: 'Invite',
    inviteHint: 'Nothing is emailed. Copy the link and send it to them yourself.',
    linkOnce: 'This link is shown once.',
    copy: 'Copy',
    copied: 'Copied',
    remove: 'Remove',
    removeConfirm: 'Click again to remove',
    resetLink: 'Password reset link',
    revoke: 'Revoke',
    expires: 'Expires',
    invitedBy: 'Invited by',
    self: 'You',
    demoteSelfConfirm:
      'Lower your own role? You will lose this page, and another admin has to give it back.',
    noInvitations: 'No invitations waiting',
  },
  platform: {
    loadFailed: 'The workspaces could not be loaded',
    title: 'All workspaces',
    hint: 'Create, suspend or delete a customer workspace.',
    tenants: 'Workspaces',
    create: 'Create a workspace',
    name: 'Name',
    slug: 'Slug (used in URLs)',
    adminEmail: "First admin's email",
    members: 'Members',
    statuses: { active: 'Active', suspended: 'Suspended', deleting: 'Deleting' },
    suspend: 'Suspend',
    suspendConfirm: 'Click again to suspend',
    unsuspend: 'Restore',
    delete: 'Delete for good',
    deleteHint: 'Deletes everything, permanently. Type the slug to confirm.',
    typeSlug: 'Type the slug to confirm',
    admins: 'Platform admins',
    adminsHint: 'Who may manage workspaces. They need an account already.',
    grant: 'Grant',
    revokeAdmin: 'Revoke',
    grantedBySeed: 'Set up by the installer',
    recovery: 'Account recovery',
    recoveryHint:
      'Issue a password reset link for an account a workspace admin may not: anyone in more than one workspace, and every platform admin.',
    issueReset: 'Issue link',
    egress: 'Approved private endpoints',
    egressHint:
      "Private or plain-http origins this workspace's AI providers and external retrieval may reach, such as a gateway on your own network. One per line. The workspace's own admins cannot set this.",
    egressNone: 'None',
    egressEdit: 'Edit',
  },
  invite: {
    unreachable: 'The server did not answer. The link may still be good; try again.',
    joinTitle: 'Join',
    resetTitle: 'Set a new password',
    name: 'Your name',
    password: 'Password',
    passwordHint: 'At least 8 characters',
    needName: 'Your name is needed.',
    accept: 'Join',
    join: 'Join this workspace',
    signInFirst: 'That address already has an account. Sign in to accept the invitation.',
    signIn: 'Sign in',
    invalid: 'That link is not valid any more',
    invalidHint: 'It may have been used, expired or revoked. Ask for another one.',
    issuedTo: 'This link was issued to',
  },
  workspace: {
    suspended: 'This workspace is suspended',
    suspendedHint: 'Talk to whoever runs the platform. Nothing has been deleted.',
    deleting: 'This workspace is being deleted',
    deletingHint: 'Its data is being removed permanently.',
    none: 'Your account is not in any workspace',
    noneHint: 'Ask an admin to invite you.',
    switch: 'Switch workspace',
  },
  notFound: {
    title: 'That page does not exist',
    hint: 'The address may be mistyped, or the page may have moved.',
    backToInbox: 'Back to the inbox',
    noWorkspace: 'No workspace by that name',
    noWorkspaceHint: 'It may be spelled differently, or your account may not be in it.',
    switching: 'Switching workspace...',
  },
  channels: {
    line: 'LINE',
    messenger: 'Messenger',
    web: 'Web',
    test: 'Simulator',
  },
  common: {
    loading: 'Loading...',
    saving: 'Saving...',
    error: 'Something went wrong',
    retry: 'Try again',
    edit: 'Edit',
    remove: 'Remove',
    removeConfirm: 'Click again to remove',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    you: 'You',
    ai: 'AI',
    customer: 'Customer',
    system: 'System',
  },
}

const STORAGE_KEY = 'ci.language'

function initialLanguage(): 'th' | 'en' {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'th' || stored === 'en') return stored
  } catch {
    // Private browsing or blocked storage: fall through to the default.
  }
  return 'th'
}

void i18next.use(initReactI18next).init({
  resources: { th: { translation: th }, en: { translation: en } },
  lng: initialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

export function setLanguage(language: 'th' | 'en'): void {
  void i18next.changeLanguage(language)
  document.documentElement.lang = language
  try {
    localStorage.setItem(STORAGE_KEY, language)
  } catch {
    // Not being able to remember the choice is not worth failing over.
  }
}

document.documentElement.lang = i18next.language

export default i18next
